import Dexie from "dexie";

/** Local device database for offline support. */
export const odb = new Dexie("julia_offline");

odb.version(1).stores({
  // Queued mutations waiting to reach the server (insertion order = sync order)
  outbox: "++id, entity, ts",
  // Photos/documents captured while offline, keyed by their temporary path
  blobs: "tempPath",
});
